var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroesseKreis04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-04__Icn/40px/Groesse-Kreis-04",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-04__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-04__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20,10 C25.5228475,10 30,14.4771525 30,20 C30,25.5228475 25.5228475,30 20,30 C14.4771525,30 10,25.5228475 10,20 C10,14.4771525 14.4771525,10 20,10 Z M20,12 C15.581722,12 12,15.581722 12,20 C12,24.418278 15.581722,28 20,28 C24.418278,28 28,24.418278 28,20 C28,15.581722 24.418278,12 20,12 Z",
    id: ".._.._src_svg_Icn_40px_Groesse-Kreis-04__Oval-Copy"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroesseKreis04);
export default __webpack_public_path__ + "static/media/Groesse-Kreis-04.c61bfeff3c09aae62e7349e2f1ed42c2.svg";
export { ForwardRef as ReactComponent };